export class ApiAccessModel {
    constructor() {

    }
    Id: string;
    Name: string;
    Scopes: string[];
    FromPhonenumbers: string[];
    Status: ApiAccessEnum;
    WebhookUrl: string;
    WebhookDisabled: boolean;
    WebhookFailureCount: number
    LastUpdatedDateTime: string;
    CreatedDateTime: string;
    WebhookDisabledDateTime: string;
    Secret?: string;
    WebhookSigningSecret?: string
}

export const mapToApiAccessModel = (x: any): ApiAccessModel => {
    return {
        Id: x.id,
        Name: x.name,
        Scopes: x.scopes,
        FromPhonenumbers: x.allowedPhoneNumbers ?? [],
        Status: x.status,
        WebhookUrl: x.webhookUrl,
        WebhookDisabled: x.webhookDisabled,
        WebhookFailureCount: x.webhookFailureCount,
        LastUpdatedDateTime: x.lastUsedDateTime,
        CreatedDateTime: x.createdDateTime,
        WebhookDisabledDateTime: x.webhookDisabledDateTime,
        Secret: x?.secret ?? "",
        WebhookSigningSecret: x?.webhookSigningSecret ?? ""
    } as ApiAccessModel
}

export enum ApiAccessEnum {
    Active,
    Revoked
}